export const TRANSFER_ORDER_ITEM_DETAIL_DIALOG = 'transferOrderItemDetailDialog';
